/**
 * Splits a camel case or Pascal case string by capital letters and inserts spaces.
 * @param {string} str - The input string to split.
 * @returns {string} The string with spaces inserted before capital letters.
 */
export function splitByCapitals(str) {
    return str.replace(/([a-z])([A-Z])/g, '$1 $2');
}


/**
 * Converts all characters in a string to lowercase.
 * @param {string} str - The input string.
 * @returns {string} The lowercase string.
 */
export function toLower(str) {
    return str.toLowerCase();
}